import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["setDefaultButton"];

  declare readonly setDefaultButtonTarget: HTMLButtonElement;

  async setDefault(event: Event) {
    event.preventDefault();

    const form = (event.target as HTMLButtonElement).closest("form");
    if (!form) return;

    const formData = new FormData(form);
    const url = form.action;

    try {
      const response = await fetch(url, {
        method: "PATCH",
        body: formData,
        headers: {
          "X-CSRF-Token":
            document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
              ?.content || "",
          Accept: "application/json",
        },
      });

      if (response.ok) {
        // Reload the page to show the updated default badge
        window.location.reload();
      } else {
        console.error("Failed to set default dashboard");
      }
    } catch (error) {
      console.error("Error setting default dashboard:", error);
    }
  }
}
